/* eslint @typescript-eslint/strict-boolean-expressions: off */

import { PageHead } from "gui/head/head";
import type { ReactNode } from "react";
import styles from "./SectionMessage.module.css";
import cn from "classnames";

export interface Props {
  heading?: string;
  subheading?: string;
  body?: ReactNode;
  image?: ReactNode;
  actions?: ReactNode;

  // If align is not defined elements will be aligned vertically: image on the top + texts on the bottom
  align?: "vertical" | "horizontal";
}

export function SectionMessage(props: Props) {
  const {
    heading,
    body,
    subheading,
    image,
    actions,
    align = "vertical",
  } = props;

  const alignmentClass = styles[`align-${align}`];

  return (
    <>
      <PageHead title={heading} />

      <div className={styles.page}>
        <section className={cn(alignmentClass)}>
          <div className={cn(styles.sectionMessage, alignmentClass)}>
            {subheading && <h2>{subheading}</h2>}
            {heading && <h1>{heading}</h1>}
            {body && (
              <div className={cn(styles.body, alignmentClass)}>{body}</div>
            )}
            <div className={cn(styles.actions, alignmentClass)}>{actions}</div>
          </div>
          {image && (
            <div className={cn(styles.image, alignmentClass)}>{image}</div>
          )}
        </section>
      </div>
    </>
  );
}
